import { render, staticRenderFns } from "./Ballroom.vue?vue&type=template&id=5b255cbd&scoped=true&"
import script from "./Ballroom.vue?vue&type=script&lang=js&"
export * from "./Ballroom.vue?vue&type=script&lang=js&"
import style0 from "./Ballroom.vue?vue&type=style&index=0&id=5b255cbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b255cbd",
  null
  
)

export default component.exports